module.exports = __webpack_public_path__ + "img/tree-02-c-leaves.3228c7da.png";